// https://vuex.vuejs.org/en/state.html

export default {
  isLogged: false,
  token: null,
  fullname: '',
  username: ''
}
